import React from 'react';
import aggregationFilterHelper from '../../../infrastructure/helpers/functions/aggregation/aggregationFilterHelper';
import StatementHelper from '../../../infrastructure/types/Functions/StatementHelper';
import Aggregation from '../../../types/report/Aggregation';
import AggregationFilter from '../../../types/report/AggregationFilter';
import StatementBlockBuilder from '../../Functions/Statement/StatementBlockBuilder';
import StatementBlockBuilderProps from '../../Functions/Statement/StatementBlockBuilderProps';
import AggregationFilterBuilder from './AggregationFilterBuilder';

interface RemoveProps {
    statements?: AggregationFilter[],
    statementHelper?: StatementHelper<AggregationFilter>
}

interface AddProps {
    aggregationNumber: number | null
}

class AggregationFilterBlockBuilder extends React.Component<Omit<StatementBlockBuilderProps<AggregationFilter>, keyof RemoveProps> & AddProps > {

    render(): JSX.Element {

        const aggregation = this.props.reportConfig.aggregations.find(a => a.number === this.props.aggregationNumber) as Aggregation;

        if (!aggregation) { 
            return <></>; }

        return (
            <StatementBlockBuilder
                childComponentType={AggregationFilterBuilder}
                isWaiting={this.props.isWaiting}
                isReadOnly={this.props.isReadOnly}
                caseNumber={null}
                reportConfig={this.props.reportConfig}
                counts={this.props.counts}
                statements={aggregation.filters}
                collections={this.props.collections}
                clipboard={this.props.clipboard}
                onChange={this.props.onChange}
                onClipboardChange={this.props.onClipboardChange}
                getOperandRuleBundle={this.props.getOperandRuleBundle}
                validateRemoveStatement={this.props.validateRemoveStatement}
                onConditionUpdate={this.props.onConditionUpdate}
                statementHelper={aggregationFilterHelper(aggregation)}
                details={{...this.props.details, parentNumber: aggregation.number}} />
        );
    }
}

export default AggregationFilterBlockBuilder;
